import ImageComponent from './ImageComponent';

function Image(props) {
  return <ImageComponent {...props} />;
}

export default Image;
